import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import fb from "../../firebase";
import { ChatRequest } from "../../interfaces";
import { userStatusChanged } from "../../redux/Chat/actions";
import { style as chatStyle } from "./ChatConversation.styled";
import { TypedUseSelectorHook } from "../../redux";

// Firebase modular imports
import { getDatabase, ref, query, orderByChild, equalTo, onValue, DataSnapshot } from "firebase/database";

interface ContactChatAvatarProps {
	image?: string | null;
	initials: string[];
	uid?: string;
	userName?: string;
	contentId?: string;
	request: ChatRequest;
}

const rtdb = getDatabase(fb);

const ContactChatAvatar: React.FC<ContactChatAvatarProps> = ({
	image,
	initials,
	uid,
	userName,
	contentId,
	request,
}) => {
	const [isOnline, setIsOnline] = useState<boolean>(!uid);

	const dispatch = useDispatch();

	const isMuted = request.userData[request.users.filter(x => x !== uid)[0]].muted;

	useEffect(() => {
		if (contentId && uid) {
			const userPresenceRef = ref(rtdb, `/analytics/user-presence/${contentId}`);
			const userPresenceQuery = query(userPresenceRef, orderByChild("firebaseId"), equalTo(uid));

			const callback = (snap: DataSnapshot) => {
				if (snap.exists()) {
					const data = Object.values(snap.val()) as { state: string }[];
					const status = data.length === 0 || data.some(x => x.state === "online");
					setIsOnline(status);
					dispatch(userStatusChanged({ uid, status }));
				}
			};

			const unsubscribe = onValue(userPresenceQuery, callback);

			return () => {
				unsubscribe();
			};
		}
	}, [uid, contentId, dispatch]);

	const useTypedSelector: TypedUseSelectorHook = useSelector;
	const { images: userImageTimestamps } = useTypedSelector(store => store.channel);
	const timestamp = uid ? userImageTimestamps[uid] : null;

	return (
		<>
			<div className={`chat-avatar`} title={isOnline ? userName : `${userName} is offline`}>
				{initials[0] === "" ? <i className="fal fa-user"></i> : <>{initials}</>}
				{image && (
					<img
						src={
							image.includes("googleusercontent")
								? image
								: `https://media.online.brushfire.com/profile_images/${uid}/profile.jpg${
										timestamp ? `?ts=${timestamp}` : ""
								  }`
						}
						alt={`${userName}'s User Image`}
					/>
				)}
			</div>
			<chatStyle.ChatAvatarStatus
				className={`${request.hostChat || isOnline ? "online" : ""}${isMuted ? " muted" : ""}`}
			>
				<i className={`fas fa-${request.hostChat ? "user-circle" : isMuted ? "moon" : "circle"}`}></i>
			</chatStyle.ChatAvatarStatus>
		</>
	);
};

export default ContactChatAvatar;
